import React ,{useState} from 'react';

const BtnSubmitValidation = (props) => {
  const [isClicked,setIsClicked]=useState(false);

  const handleSubmit =()=>{
    setIsClicked(true)
    if(!props.disableReasonText){
      props?.onclick();
    }
  }

  let className = props?.isBusiness ? 'btn-submit-purple' : 'btn-submit';
  if (props.className) {
    className += ' ' + props.className;
  }

  return (
    <>
    {
      isClicked &&  props.disableReasonText &&
      <span className ="disableReasonText">{props.disableReasonText}</span>
    }
    <button
      id='btnSubmit'
      type={props.type ?? 'submit'}
      className={className}
      form={props?.formid}
      onClick={()=>handleSubmit()}
     >

      {props?.isDisplayWhatsAppIcon && <span className='whatsapp-icon'></span>}
      <span htmlFor='btnSubmit' className='btn-submit__label'>
        {props?.text}
      </span>
      {props?.isDisplayArrows && <span className='arrows-icon'></span>}
    </button>
    </>
  );
};

export default BtnSubmitValidation;
